//
//
//
//
//
//
//
//
//

export default {
  name: 'firstbit',
  data () {
    return {}
  }
}
